import * as React from 'react';
import styled from 'styled-components';

import * as colors from '../../shared/colors';
import { loadJSData } from '../../shared/jsData';
import t from '../../shared/translations';

const Column = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    min-height: 100vh;
`;

const Logo = styled.img`
    margin-top: 0.5rem;
    max-height: 5rem;
    max-width: 290px;
    object-fit: scale-down;

    @media (min-width: 600px) {
        max-width: 33%;
    }
`;

const ButtonLink = styled.a`
    display: block;
    padding: 1rem 2rem 1.0625rem;
    color: white;
    background-color: ${colors.primaryColor};
    margin: 0.5rem 0;
    width: 150px;
    text-align: center;

    &:hover, &:focus, &:active, &:visited {
        color: white;
    }
`;

function LangPicker(): JSX.Element {
    const logoSrc = loadJSData().settings.logo_src;
    const langs = loadJSData().languages;
    return <Column>
        <h1>{t('public.builder-lang-picker.heading')}</h1>
        {langs.includes('en') && <ButtonLink href='/path-builder/en'>
            {t('shared.language.en')}
        </ButtonLink>}
        {/* {langs.includes('de') && <ButtonLink href='/path-builder/de'>
            {t('shared.language.de')}
        </ButtonLink>}
        {/* {langs.includes('es') && <ButtonLink href='/path-builder/es'>
            {t('shared.language.de')}
        </ButtonLink>}
        {langs.includes('sv') && <ButtonLink href='/path-builder/sv'>
            {t('shared.language.sv')}
        </ButtonLink>}
        {langs.includes('fi') && <ButtonLink href='/path-builder/fi'>
            {t('shared.language.fi')}
        </ButtonLink>} */}
        <Logo src={logoSrc} />
    </Column>;
}

export default LangPicker;
